export const instituteCourses = [
  {
    slug: "mern-stack",
    name: "MERN Stack",
    title: "MERN Stack Development",
    route: "/institute/mern-stack",
    seoTitle: "MERN Stack Course in Karaikudi | WE3X Institute",
    seoDescription:
      "Learn MERN Stack development at WE3X Institute with practical training in MongoDB, Express.js, React.js and Node.js.",
  },
  {
    slug: "digital-marketing",
    name: "Digital Marketing",
    title: "Digital Marketing",
    route: "/institute/digital-marketing",
    seoTitle: "Digital Marketing Course in Karaikudi | WE3X Institute",
    seoDescription:
      "Learn digital marketing at WE3X Institute with practical training in SEO, Google Ads, social media, analytics and lead generation.",
  },
  {
    slug: "ui-ux",
    name: "UI/UX",
    title: "UI/UX Design",
    route: "/institute/ui-ux",
    seoTitle: "UI/UX Design Course in Karaikudi | WE3X Institute",
    seoDescription:
      "Learn UI/UX design at WE3X Institute through user research, wireframes, visual design, prototypes and usability principles.",
  },
  {
    slug: "python-full-stack",
    name: "Python Full Stack",
    title: "Python Full Stack",
    route: "/institute/python-full-stack",
    seoTitle: "Python Full Stack Course in Karaikudi | WE3X Institute",
    seoDescription:
      "Learn Python full stack development at WE3X Institute with frontend, backend, databases, APIs and practical project training.",
  },
  {
    slug: "tally-prime",
    name: "Tally Prime",
    title: "Tally Prime",
    route: "/institute/tally-prime",
    seoTitle: "Tally Prime Course in Karaikudi | WE3X Institute",
    seoDescription:
      "Learn Tally Prime, GST, accounting, inventory and business transaction workflows at WE3X Institute.",
  },
  {
    slug: "basic-computers",
    name: "Basic Computers",
    title: "Basic Computers",
    route: "/institute/basic-computers",
    seoTitle: "Basic Computer Course in Karaikudi | WE3X Institute",
    seoDescription:
      "Build essential computer skills for education, office work and everyday productivity at WE3X Institute.",
  },
  {
    slug: "cyber-security",
    name: "Cyber Security",
    title: "Cyber Security",
    route: "/institute/cyber-security",
    seoTitle: "Cyber Security Course in Karaikudi | WE3X Institute",
    seoDescription:
      "Learn cybersecurity foundations, networking, threats, vulnerabilities and protection practices at WE3X Institute.",
  },
];

export const instituteCourseMap = Object.fromEntries(
  instituteCourses.map((course) => [course.slug, course])
);
